import React from 'react'
import { Icon } from 'labguard-cdk'

const AdjustmentCertificateIcon = domProps => (
  <Icon icon="sliders-h" {...domProps} transform="shrink-8 down-2 rotate-90" mask="file" />
)

export default AdjustmentCertificateIcon
